export const BRAND_NAME = 'Rock8Exch';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'rock8exch.com';
export const PROVIDER_ID = 'BetFair';
